import { combineReducers } from 'redux';
import councils, * as dataSelectors from './regions';
import ui, * as uiSelectors from './ui';

const rootReducer = combineReducers({
  data: councils,
  ui: ui,
});

export default rootReducer;

export const getCouncils = (state) => dataSelectors.getCouncilsData(state.data);

export const getRegions = (state) => dataSelectors.getRegionsData(state.data);

export const getDams = (state) => dataSelectors.getDamsData(state.data);

export const getQldCouncilsGeo = (state) =>
  dataSelectors.getQldCouncilsGeo(state.data);

export const getIsFetchingCouncils = (state) =>
  uiSelectors.getIsFetchingCouncils(state.ui);

export const getIsMobile = (state) => uiSelectors.getIsMobile(state.ui);

export const getActiveCouncil = (state) => {
  const activeCouncilId = uiSelectors.getActiveCouncil(state.ui);
  return activeCouncilId
    ? dataSelectors
        .getRegionsData(state.data)
        .find((council) => council.id === activeCouncilId)
    : null;
};

export const getActiveDam = (state) => {
  const activeDamName = uiSelectors.getActiveDam(state.ui);
  return activeDamName
    ? dataSelectors
        .getDamsData(state.data)
        .find((dam) => dam.dam === activeDamName)
    : null;
};

export const getDamsByRegion = (state) => {
  const dams = getDams(state);
  const activeCouncil = getActiveCouncil(state);
  return activeCouncil
    ? dams.filter((x) => x.region === activeCouncil.name)
    : [];
};

export const getActivePage = (state) => uiSelectors.getActivePage(state.ui);



// WEBPACK FOOTER //
// ./src/reducers/index.js